module.exports = __webpack_public_path__ + "static/media/pic11.9e2c19d6.jpg";